import React from "react";
import { PortfolioData } from "./PortfolioData";
import "../css/mainPortfolio.css";
import strongArrow from "../img/portfolio/bordArrow.png";
import { useNavigate } from "react-router-dom";

export default function MainPortfolio() {
  // id로 데이터를 불러와서 포트폴리오 화면에 정렬
  const targetId = [1, 2, 3];
  const nav = useNavigate();

  const items = PortfolioData.filter((item) => targetId.includes(item.id));
  return (
    <section className="mainPortfolio">
      <div className="mainPortfolio_inner">
        <div className="title_wrap">
          <h3>PORTFOLIO</h3>
          <div className="title_heder">
            <strong>데이터파이브 포트폴리오</strong>
            <button onClick={() => nav("/portfolio")}>
              더보기 &nbsp; <img src={strongArrow} alt="더보기" />
            </button>
          </div>
        </div>
        <div className="Portfolio_box">
          {items &&
            items.map((item) => (
              <div key={item.id} className="Portfolio_item">
                <figure>
                  <div className="image_box">
                    <img src={item.image} alt={item.title} />
                  </div>

                  <figcaption>
                    <div className="typesBox">
                      {item.types.map((type, index) => (
                        <img key={index} src={type} alt={type} />
                      ))}
                    </div>
                    <h4>{item.title}</h4>
                    <p>{item.text}</p>
                  </figcaption>
                </figure>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}
